import regeneratorRuntime from "/app/node_modules/.pnpm/next@12.1.0_542dbb8244055def7e2942da0a515fa8/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-len */ // import '@tencent/particle-ui/dist/pui.css';
// import '@tencent/cms-design-component/lib/dist/style/main.css';
import logger from 'common/utils/udp-logger';
import Head from 'next/head';
import { getTips } from 'portal-common/components/LanguagNone/resource/trans-tip';
import React from 'react';
import { getPriceTabData } from '../apis/buyApi';
import { getPageDetail } from '../apis/cmsApi';
// import { queryFormInfo } from '../apis/formApi';
import GemsRender from '../components/GemsRender';
import OldRender from '../components/OldRender';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
export var getData = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(param) {
        var locale, defaultLocale, eid, isPreview, domains, lg, ref, data, msg, code, isNewEditorData, components, ref1, ref2, ref3, ref4, ref5, langTip, noticeCom, item1, ref6, code1, pData;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locale = param.locale, defaultLocale = param.defaultLocale, eid = param.eid, isPreview = param.isPreview, domains = param.domains;
                    lg = locale || defaultLocale;
                    _ctx.prev = 2;
                    if (!(eid === 'undefined')) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        notFound: true
                    });
                case 5:
                    _ctx.next = 7;
                    return getPageDetail(eid, isPreview);
                case 7:
                    ref = _ctx.sent;
                    data = ref.data;
                    msg = ref.msg;
                    code = ref.code;
                    if (!(!code && data)) {
                        _ctx.next = 28;
                        break;
                    }
                    isNewEditorData = !!data.langPage;
                    components = [];
                    if (isNewEditorData) {
                        ;
                        components = ((ref1 = data.langPage[lg]) === null || ref1 === void 0 ? void 0 : ref1.components) || [];
                    } else {
                        ;
                        components = (ref2 = data.components) === null || ref2 === void 0 ? void 0 : ref2.filter(function(item) {
                            return item.lang === lg;
                        });
                    }
                    if (components.length === 0) {
                        ;
                        langTip = getTips('express', lg);
                        lg = 'en';
                        components = ((ref3 = data.langPage) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.en) === null || ref4 === void 0 ? void 0 : ref4.components) || ((ref5 = data.components) === null || ref5 === void 0 ? void 0 : ref5.filter(function(item) {
                            return item.lang === lg;
                        })) || [];
                        noticeCom = {
                            id: 'component/Notice',
                            name: 'Notice',
                            key: 999,
                            style: {},
                            commonStyle: {},
                            wrapperStyle: {},
                            data: {
                                noFix: true,
                                longTimeMode: true,
                                noticeDesc: langTip,
                                noticeType: 'notice'
                            }
                        };
                        components.unshift(noticeCom);
                    }
                    if (!(components.length === 0)) {
                        _ctx.next = 19;
                        break;
                    }
                    logger.error('notFound', {
                        desc: 'components length == 0',
                        locale: locale,
                        defaultLocale: defaultLocale,
                        eid: eid,
                        isPreview: isPreview
                    });
                    return _ctx.abrupt("return", {
                        notFound: true
                    });
                case 19:
                    item1 = components.find(function(item) {
                        return item.component_id === 'ProductsService' && item.lang === lg || item.name === 'ProductsService';
                    });
                    if (!item1) {
                        _ctx.next = 27;
                        break;
                    }
                    _ctx.next = 23;
                    return getPriceTabData(lg, domains);
                case 23:
                    ref6 = _ctx.sent;
                    code1 = ref6.code;
                    pData = ref6.data;
                    if (!code1) {
                        if (isNewEditorData) {
                            item1.data.productsServiceData = pData;
                        } else {
                            item1.productsServiceData = pData;
                        }
                    } else {
                        logger.error('getPriceTabData', {
                            lg: lg,
                            pData: pData,
                            code: code1
                        });
                        // 如果请求异常就删除该组件的显示
                        components.splice(components.indexOf(item1), 1);
                    }
                case 27:
                    return _ctx.abrupt("return", {
                        props: {
                            code: code,
                            msg: msg,
                            lang: lg,
                            isPreview: isPreview,
                            configData: data,
                            domains: domains
                        }
                    });
                case 28:
                    logger.error('notFound', {
                        locale: locale,
                        defaultLocale: defaultLocale,
                        eid: eid,
                        isPreview: isPreview
                    });
                    return _ctx.abrupt("return", {
                        notFound: true
                    });
                case 32:
                    _ctx.prev = 32;
                    _ctx.t0 = _ctx["catch"](2);
                    logger.error('getData', {
                        desc: 'no data',
                        locale: locale,
                        defaultLocale: defaultLocale,
                        eid: eid,
                        isPreview: isPreview,
                        error: _ctx.t0
                    });
                    throw _ctx.t0;
                case 36:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                32
            ]
        ]);
    }));
    return function getData(_) {
        return _ref.apply(this, arguments);
    };
}();
// export const getRenderData = async ({ locale, defaultLocale, eid, isPreview, domains }) => {
//   const HomeAjax = require('portal-common/server/routes/render/ajax/index');
//   let lg = locale || defaultLocale;
//   try {
//     if (eid === 'undefined') {
//       return {
//         notFound: true,
//       };
//     }
//     const { data } = await HomeAjax.getPageInfo(eid, isPreview);
//     console.log('getRenderData--getPageInfo-', data);
//     // if (!code && data) {
//     //   const isNewEditorData = !!data.langPage;
//     //   let components = [];
//     //   if (isNewEditorData) {
//     //     components = data.langPage[lg]?.components || [];
//     //   } else {
//     //     components = data.components?.filter((item) => item.lang === lg);
//     //   }
//     //   if (components.length === 0) {
//     //     const langTip = getTips('express', lg);
//     //     lg = 'en';
//     //     components = data.langPage?.en?.components || data.components?.filter((item) => item.lang === lg) || [];
//     //     const noticeCom = {
//     //       id: 'component/Notice',
//     //       name: 'Notice',
//     //       key: 999,
//     //       style: {},
//     //       commonStyle: {},
//     //       wrapperStyle: {},
//     //       data: {
//     //         noFix: true,
//     //         longTimeMode: true,
//     //         noticeDesc: langTip,
//     //         noticeType: 'notice',
//     //       },
//     //     };
//     //     components.unshift(noticeCom);
//     //   }
//     //   if (components.length === 0) {
//     //     logger.error('notFound', { desc: 'components length == 0', locale, defaultLocale, eid, isPreview });
//     //     return {
//     //       notFound: true,
//     //     };
//     //   }
//     //   // const item = components.find((item) => (item.component_id === 'ProductsService' && item.lang === lg) || item.name === 'ProductsService');
//     //   // if (item) {
//     //   //   const { code, data: pData } = await getPriceTabData(lg, domains);
//     //   //   if (!code) {
//     //   //     if (isNewEditorData) {
//     //   //       item.data.productsServiceData = pData;
//     //   //     } else {
//     //   //       item.productsServiceData = pData;
//     //   //     }
//     //   //   } else {
//     //   //     logger.error('getPriceTabData', { lg, pData, code });
//     //   //     // 如果请求异常就删除该组件的显示
//     //   //     components.splice(components.indexOf(item), 1);
//     //   //   }
//     //   // }
//     //   // const table = components.find((item) => (item.component_id === 'FormTable' && item.lang === lg) || item.name === 'FormTable');
//     //   // if (table) {
//     //   //   const commodityObject = table.data.commodityObject || '{}';
//     //   //   if (commodityObject) {
//     //   //     const obj = JSON.parse(commodityObject);
//     //   //     const commodity = obj.commodity || '';
//     //   //     const { code, data: tData } = await HomeAjax.queryFormInfo({ ecId: commodity });
//     //   //     if (!code) {
//     //   //       table.data.tableData = JSON.parse(tData.customizeQust || '[]') || [];
//     //   //     } else {
//     //   //       logger.error('queryFormInfo', { lg, tData, code });
//     //   //       // 如果请求异常就删除该组件的显示
//     //   //       // components.splice(components.indexOf(table), 1);
//     //   //     }
//     //   //   }
//     //   // }
//     //   console.log('getRenderData---', data);
//     //   return {
//     //     props: {
//     //       code,
//     //       msg,
//     //       lang: lg,
//     //       isPreview,
//     //       configData: data,
//     //       domains,
//     //     },
//     //   };
//     // }
//     logger.error('notFound', { locale, defaultLocale, eid, isPreview });
//     return {
//       notFound: true,
//     };
//   } catch (error) {
//     logger.error('getData', {
//       desc: 'no data',
//       locale,
//       defaultLocale,
//       eid,
//       isPreview,
//       error,
//     });
//     throw error;
//   }
// };
export var pageRenderer = function(props) {
    var code = props.code, configData = props.configData, location = props.location, lang = props.lang, isPreview = props.isPreview, domains = props.domains;
    if (code) {
        return(/*#__PURE__*/ _jsx("div", {}));
    }
    try {
        var isNewData = !!configData.langPage;
        var pageObject = configData.pageObject;
        if (typeof pageObject === 'string') {
            pageObject = JSON.parse(pageObject);
        }
        var langInfo = (pageObject === null || pageObject === void 0 ? void 0 : pageObject.langs[lang]) || {};
        if (Object.keys(langInfo).length === 0) {
            langInfo = pageObject.langs.en;
        }
        return(/*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs(Head, {
                    children: [
                        /*#__PURE__*/ _jsx("title", {
                            children: langInfo.title || ''
                        }),
                        /*#__PURE__*/ _jsx("meta", {
                            name: "description",
                            content: langInfo.description || ''
                        }),
                        /*#__PURE__*/ _jsx("meta", {
                            name: "keywords",
                            content: langInfo.keyword || ''
                        })
                    ]
                }),
                isNewData ? /*#__PURE__*/ _jsx(GemsRender, {
                    lang: lang,
                    configData: configData,
                    isPreview: isPreview,
                    domains: domains
                }) : /*#__PURE__*/ _jsx(OldRender, {
                    lang: lang,
                    configData: configData,
                    location: location,
                    isPreview: isPreview
                })
            ]
        }));
    } catch (error) {
        logger.error('pageRenderer', {
            code: code,
            configData: configData,
            location: location,
            lang: lang,
            isPreview: isPreview,
            error: error
        });
        throw error;
    }
};
